import * as React from "react"
import {withStyles, WithStyles, StyleRules, ClassNameMap} from "@mui/styles"
import AppView from "~common/components/app-view/index"
import ErrorView from "~common/components/error-view"
import LoadingView from "~common/components/loading-view"
import {Theme} from "@mui/styles"
import {APIError} from "~common/lib/types"
import SelectableTable from "~common/components/table/selectable-table"
import Require from "~common/components/require"
import FeatureProxyEditView from "../components/feature-proxy-edit"
import {Typography} from '@mui/material';
import ProxyAdminQueryList from "~users/components/feature-proxy-query-view.tsx"




const styles = (theme: Theme): StyleRules => ({
  container: {
    width: "100%",
  },
})

interface Props extends React.HTMLProps<HTMLDivElement> {
  history: any
}

type State = {
  error?: APIError
  status: "loading" | "ready"
  items: Array<any>
}

class FeatureProxyAdmin extends React.Component<Props & WithStyles<keyof typeof styles>, State> {	
  constructor(props: Props & WithStyles<keyof typeof styles>) {
    super(props, {})
    this.state = {
        status: "loading",
        items: []
    }
  }

 componentDidMount() {
    this.setState({status: "ready"})
  }

  handleAttributeChange = (attr: any): any => (event: any): void => {
    if (attr.handleChange) {
      attr.handleChange(event)
      this.setState({})
    }
  }
  
  handleAddNew = () => {
		window.location.href = '/feature-proxy/admin/new';
    };
    
    onErrorClose = () => {
        this.setState({
            error: undefined
        })
    }

  render() {

    const {match} = this.props;
    const portalUserID = match.params.id
    const {classes, history}: {classes: ClassNameMap; history: any} = this.props
    const {error, status, items} = this.state

    const rowActions = [
        {
          key: "edit",
          icon: "create",
          label: "Edit Proxy",
          action: (selected: any) => {
            // console.log("You have selected ",  selected)
            history.push("/feature-proxy/admin/" + selected.portalUserID)
          },
        },
      ]
  
    var errorView 
    if (error) {
      errorView = <ErrorView onClose={this.onErrorClose} classes={{}} error={error} />
    }

    var view 
    if (status === "loading") {
      view = <LoadingView classes={{}} />
    } else if (portalUserID) {   
        view = (<FeatureProxyEditView portalUserID={portalUserID} history={history} classes={{}} />)
    } else {
      view = (
          <ProxyAdminQueryList />
    	)
    }

    return (
      <AppView history={history} areaKey="feature_proxy_admin">
        <Require classes={{}} >
            {errorView}
            <Typography id="featureProxyAdminTitle" variant="h5" className={classes.heading}>
               Feature Proxy Administration
            </Typography>
            <div className={classes.container}>{view}</div>
        </Require>
      </AppView>
    )
  }
}

export default withStyles(styles)(FeatureProxyAdmin)
